{
  "supabase": {
    "invalidCredentials": "Wrong email or password",
    "emailNotConfirmed": "Email not confirmed. Check your inbox (and spam folder)",
    "userAlreadyRegistered": "An account with this email already exists",
    "passwordTooShort": "Password must be at least 6 characters",
    "rateLimited": "Too many attempts. Wait a moment and try again",
    "invalidEmail": "That email address doesn't look valid",
    "sessionMissing": "Your session has expired. Log in again",
    "tokenExpired": "The link has expired. Request a new one",
    "passwordSameAsOld": "The new password must differ from the current one",
    "unknown": "Something went wrong. Try again"
  },
  "generic": {
    "networkError": "Couldn't reach the server. Check your connection",
    "serverError": "The server returned an error. Try again shortly",
    "unknown": "Unexpected error. Try again"
  },
  "api": {
    "trade_feed_invalid_limit": "That page size isn't valid",
    "trade_feed_invalid_offset": "That page isn't valid",
    "trade_feed_offset_too_deep": "The trade list doesn't go back that far. Use the filters to narrow it down",
    "trade_feed_invalid_type": "That trade type isn't valid",
    "trade_feed_invalid_division": "That division isn't valid",
    "trade_feed_invalid_team": "That team isn't valid",
    "flash_deadline_day_only": "Flash auctions are only available during Deadline Day",
    "rider_not_found": "Rider not found",
    "rider_unavailable": "This rider isn't available",
    "rider_retired_auction": "This rider has retired and can't be put up for auction",
    "rider_pending_transfer_auction": "This rider was won at auction and is awaiting transfer to the new team",
    "rider_other_manager": "This rider belongs to another manager",
    "rider_has_active_auction": "This rider already has an active auction",
    "rider_in_open_swap_auction": "This rider is offered in an open swap. Withdraw the swap offer before starting an auction",
    "rider_on_auction_transfer": "This rider is on an active auction. Bid on the auction instead of making a transfer offer.",
    "rider_on_auction_swap": "One of the swapped riders is on an active auction. The swap was cancelled. Bid on the auction instead.",
    "rider_on_auction_release": "This rider is currently on auction and can't be released. Wait for the auction to end first",
    "invalid_start_price": "Invalid starting price",
    "invalid_offer_amount": "Invalid amount",
    "invalid_loan_amount": "Invalid amount",
    "start_price_own_range": "Starting price must be between 0 and the rider's Value ({value} CZ$)",
    "start_price_min_value": "Starting price must at least match the rider's Value ({value} CZ$)",
    "start_bid_exceeds_balance": "The starting bid exceeds your available balance, including active auction leads",
    "cannot_auction_squad_risk": "You can't drop below {minRiders} riders once contract expiry and retirement risk at the next season change are counted. {atRiskCount} rider(s) currently count as at-risk: {atRiskNames}",
    "auction_not_found": "Auction not found",
    "auction_not_active": "This auction is no longer active",
    "auction_expired": "The auction has ended",
    "cannot_bid_own_rider": "You can't bid on your own rider",
    "invalid_bid_amount": "Bid amount must be a positive whole number",
    "bid_below_minimum": "Bid must be at least {min} CZ$",
    "insufficient_balance_after_bids": "You have {available} CZ$ left after your existing bids",
    "bid_save_failed": "Your bid couldn't be saved. Try again.",
    "invalid_proxy_max": "Invalid max limit",
    "cannot_proxy_own_rider": "You can't set an auto-bid on your own rider",
    "proxy_below_minimum": "Max limit must be at least {min} CZ$",
    "insufficient_balance_after_proxy": "You have {available} CZ$ left after your existing bids and auto-bids",
    "proxy_save_failed": "Your auto-bid couldn't be saved. Try again.",
    "proxy_place_failed": "Your auto-bid couldn't be placed. Try again.",
    "proxy_update_failed": "Your auto-bid couldn't update the auction. Try again.",
    "rate_bid": "Too many bids in a short time. Try again in a moment.",
    "rate_market": "Too many market actions in a short time. Wait a moment.",
    "rate_board": "Too many board actions in a short time. Wait a moment.",
    "rate_request": "Too many requests in a short time. Wait a moment.",
    "rate_feedback": "Too many submissions in a short time. Try again shortly.",
    "rate_billing": "Too many billing actions in a short time. Try again shortly.",
    "rider_not_owned": "You don't own this rider",
    "rider_is_academy": "Academy riders are managed in your academy. Graduate them to your senior squad first.",
    "rider_not_academy": "This rider isn't in your academy",
    "rider_retired": "This rider has retired",
    "rider_state_changed": "This rider is no longer on your team",
    "cannot_afford_release": "You can't afford the buyout fee ({fee} CZ$). Your balance is {balance} CZ$",
    "cannot_release_squad_risk": "You can't drop below {minRiders} riders once contract expiry and retirement risk at the next season change are counted. {atRiskCount} rider(s) currently count as at-risk: {atRiskNames}",
    "checkout_paused": "Purchases are temporarily paused while I finish the terms of sale",
    "terms_not_accepted": "You must accept the terms of sale before completing your purchase",
    "terms_version_mismatch": "The terms of sale have been updated. Please review and accept the latest version",
    "no_subscription": "You don't have an active subscription",
    "already_subscribed": "You already have an active CZ Pro subscription. Manage it under Settings.",
    "pro_required": "This is a Pro feature",
    "contract_extension_cap_reached": "This contract can't be extended any further: the end season can't go beyond season {maxSeason}",
    "not_owned": "You don't own this rider",
    "not_academy": "This rider isn't in your academy",
    "already_academy": "This rider is already in your academy",
    "not_u23": "Only U23 riders can be moved to the academy",
    "squad_cap_violation": "Your senior squad is full",
    "rider_on_market": "This rider is in an active auction. End it before moving the rider to the academy",
    "rider_listed": "This rider is on the transfer list. Remove the listing before moving the rider to the academy",
    "academy_full": "Your academy is full",
    "academy_disabled": "The academy isn't available right now",
    "promotion_pending_disabled": "Promotion from the waiting list isn't available right now",
    "promotion_pending_failed": "Something went wrong with promotion from the waiting list. Try again in a moment",
    "rider_retired_listing": "This rider has retired and can't be listed for sale",
    "rider_already_listed": "This rider is already listed on the transfer market",
    "rider_on_auction_listing": "This rider is on auction right now. You can list the rider once the auction has ended",
    "listing_not_found": "Listing not found",
    "listing_not_owner": "This isn't your listing",
    "listing_already_closed": "This listing is already closed",
    "listing_unavailable": "Listing not found",
    "cannot_bid_own_listing": "You can't bid on your own listing",
    "rider_not_found_or_no_team": "Rider not found or has no team",
    "rider_retired_trade": "This rider has retired and can't be traded",
    "ai_rider_no_auction": "AI-owned riders can't be put up for auction.",
    "ai_rider_no_direct_offer": "AI riders can't receive direct offers. Start or bid on an auction instead.",
    "cannot_afford_offer": "You can't afford this offer",
    "squad_full": "Your squad is full ({effectiveCap} riders, Div {division} cap {maxRiders})",
    "squad_full_buffer": "Your squad is full ({effectiveCap} riders, Div {division} cap {maxRiders})",
    "no_eligible_room_bid": "No room on the youth team he would join ({maxAcademy}/{maxAcademy}) or in your senior squad ({maxRiders}/{maxRiders}). Sell a rider before you bid.",
    "squad_full_bid": "Your squad is full ({maxRiders} riders). Sell a rider before you bid on a new one.",
    "offer_not_found": "Offer not found",
    "not_involved_offer": "You're not involved in this offer",
    "only_closed_offers_archivable": "Only closed offers can be archived",
    "only_closed_swaps_archivable": "Only closed swaps can be archived",
    "buyer_cannot_afford": "The buyer can't afford this",
    "cannot_afford": "You can't afford this",
    "deal_locked_both_confirmed": "The deal has been accepted by both parties and can't be cancelled by a manager",
    "invalid_action": "Invalid action",
    "invalid_squad": "Pick the senior squad, U23 team or junior team",
    "offered_rider_not_owned": "Your offered rider doesn't belong to your team",
    "offered_rider_retired": "Your offered rider has retired and can't be traded",
    "target_rider_not_found": "Target rider not found or has no team",
    "target_rider_retired": "The target rider has retired and can't be traded",
    "cannot_swap_self": "You can't swap with yourself",
    "ai_rider_no_swap": "AI riders can't take part in direct swaps. Use auctions instead.",
    "offered_rider_on_auction": "Your offered rider is in an active auction and can't be offered in a swap until the auction has ended",
    "requested_rider_on_auction": "The target rider is in an active auction and can't be part of a swap until the auction has ended",
    "cannot_afford_cash_adjustment": "You can't afford the requested cash payment",
    "swap_not_found": "Swap not found",
    "not_involved_swap": "You're not involved in this swap",
    "cannot_afford_counter": "You can't afford this counter-offer",
    "counter_offer_not_open": "The counter offer is no longer open",
    "counter_withdraw_not_seller": "Only the seller can withdraw their counter offer",
    "counter_withdraw_failed": "Could not withdraw the counter offer. Please try again.",
    "counter_accept_failed": "Could not accept the counter offer. Please try again.",
    "swap_locked_both_confirmed": "The swap has been accepted by both parties and can't be cancelled by a manager",
    "transfer_price_below_floor": "This price is too low for a player trade. At least {floorPrice} CZ$ is required (fair-play price floor).",
    "transfer_price_above_cap": "This price is too high for a player trade. At most {capPrice} CZ$ is allowed (fair-play price cap).",
    "swap_price_below_floor": "This swap's combined value is too low. It must be worth at least {floorPrice} CZ$ (fair-play price floor).",
    "swap_price_above_cap": "This swap's combined value is too high. It can't exceed {capPrice} CZ$ (fair-play price cap).",
    "auction_start_price_below_floor": "The starting price is too low. It must be at least {floorPrice} CZ$ (fair-play price floor).",
    "auction_start_price_above_cap": "The starting price is too high. It can't exceed {capPrice} CZ$ (fair-play price cap).",
    "loan_max_one_season": "A loan can cover one season at most. Set the start and end to the same season number.",
    "rider_retired_loan": "This rider has retired and can't be loaned",
    "cannot_loan_own_rider": "You can't loan your own rider",
    "rider_already_loaned": "This rider is already on loan or has a pending loan proposal",
    "squad_full_loan_propose": "Your squad is full ({effectiveCap} riders, Div {division} cap {maxRiders}). The loan can't be created.",
    "squad_full_loan_propose_buffer": "Your squad is full ({effectiveCap} riders, Div {division} cap {maxRiders}). The loan can't be created.",
    "loan_not_found": "Loan not found",
    "not_involved_loan": "You're not involved in this loan",
    "squad_full_loan_accept": "The borrower's squad is full ({effectiveCap} riders, Div {division} cap {maxRiders}). The loan can't be activated.",
    "squad_full_loan_accept_buffer": "The borrower's squad is full ({effectiveCap} riders, Div {division} cap {maxRiders}). The loan can't be activated.",
    "borrower_team_not_found": "Borrowing team not found",
    "loan_fee_insufficient": "The borrower only has {available} CZ$ available after active bids and can't pay the loan fee of {fee} CZ$",
    "loan_active_no_unilateral_cancel": "This loan is active and can't be cancelled unilaterally. Contact an admin.",
    "team_not_found": "Team not found",
    "buyout_insufficient": "You only have {available} CZ$ available after active bids and can't exercise the buy option of {price} CZ$",
    "buyout_rider_unavailable": "This rider is no longer available for the buy option; it's already part of another deal.",
    "seller_no_longer_owns_rider": "The seller no longer owns the rider; the deal has been cancelled",
    "seller_squad_too_small": "The seller can't drop below {minRiders} riders in Division {division}; the deal has been cancelled",
    "seller_squad_risk_too_small": "The seller can't drop below {minRiders} riders once contract expiry and retirement risk at the next season change are counted; the deal has been cancelled",
    "buyer_squad_full": "The buyer's squad can hold at most {maxRiders} riders in Division {division}; the deal has been cancelled",
    "buyer_insufficient_balance": "The buyer can no longer afford it; the deal has been cancelled",
    "offered_rider_moved": "Your offered rider no longer belongs to your team; the swap has been cancelled",
    "requested_rider_moved": "The requested rider no longer belongs to the other team; the swap has been cancelled",
    "proposing_insufficient_balance": "The proposing team can no longer afford it; the swap has been cancelled",
    "receiving_insufficient_balance": "The receiving team can no longer afford it; the swap has been cancelled",
    "stale_rider_state": "The rider changed status during confirmation; the deal has been cancelled",
    "stale_offered_rider_state": "The offered rider changed status during confirmation; the swap has been cancelled",
    "stale_requested_rider_state": "The requested rider changed status during confirmation; the swap has been cancelled",
    "offer_missing": "Offer not found",
    "swap_missing": "Swap not found",
    "not_involved": "You're not involved in this deal",
    "not_awaiting_confirmation": "Invalid action",
    "already_confirmed": "You've already confirmed",
    "board_dna_required_plan": "You must choose your club DNA before negotiating the board plan",
    "board_dna_required_sign": "You must choose your club DNA before signing the board plan",
    "board_renegotiation_locked_window": "The season's final phase has begun. The board plan can't be renegotiated in the last {raceDays} race days.",
    "board_renegotiation_locked_progress": "The board plan can't be renegotiated mid-season (once {percent}% of the season has been raced). Wait until the plan expires or the season ends.",
    "board_renegotiation_locked_plan_active": "This {planType} plan is still active. It can only be renegotiated once its full term is complete.",
    "board_unavailable": "Board features aren't available yet",
    "mandate_id_required": "mandateId is required",
    "board_mandate_not_found": "Mandate not found",
    "board_mandate_not_proposed": "This mandate can't be signed right now",
    "board_mandate_season_ended": "This mandate belongs to a season that has ended",
    "board_mandate_request_already_used": "This mandate's annual meeting request has already been used",
    "board_mandate_sign_conflict": "This mandate can't be signed right now",
    "board_mandate_adjustment_budget_exceeded": "You've used more adjustments than your board allows this year",
    "board_bonus_credit_failed": "Could not credit the bonus. The offer was not changed, please try again.",
    "dna_requires_identity_basis": "Your club identity isn't ready yet. Try again in a moment.",
    "dna_already_chosen": "Your club DNA is already set and can't be changed yet",
    "invalid_asking_price": "The asking price must be a positive whole number",
    "bulk_price_empty": "No listings selected",
    "bulk_price_too_many": "Max {max} listings per call",
    "update_failed": "This listing couldn't be updated. Try again.",
    "team_transfer_frozen": "Your team is frozen because its debt is over the division ceiling. Reduce your debt before trading.",
    "offer_rider_amount_required": "rider_id and offer_amount are required",
    "swap_rider_ids_required": "offered_rider_id and requested_rider_id are required",
    "loan_fields_required": "rider_id, start_season and end_season are required",
    "loan_end_before_start": "end_season must be greater than or equal to start_season",
    "discord_id_required_first": "Add your Discord ID first",
    "enabled_must_be_boolean": "enabled must be a boolean",
    "team_required": "You need a team first",
    "assistant_opt_in_not_active": "The assistant is not opt-in right now",
    "unknown_pref_keys": "Unknown preference key",
    "username_invalid": "Username must be 3-20 characters (letters, numbers, _ or -)",
    "username_taken": "Username is taken",
    "invalid_loan_type": "Invalid loan type. Use short or long",
    "invalid_amount": "Invalid amount",
    "offer_id_required": "offer_id is required",
    "unknown_dna_key": "Unknown DNA key",
    "unknown_interval": "Unknown plan interval",
    "unknown_currency": "Unknown currency",
    "plan_unavailable": "This plan isn't available right now",
    "test_account_delete_needs_confirm": "{username} is a permanent test account. Confirm explicitly to delete it.",
    "feedback_invalid_category": "Invalid category",
    "feedback_message_required": "Message is required",
    "feedback_message_too_long": "Message is too long",
    "feedback_insert_failed": "Could not submit feedback",
    "feedback_missing_id": "Missing feedback id",
    "feedback_invalid_status": "Invalid status",
    "feedback_not_found": "Feedback not found",
    "feedback_reply_required": "Reply is required",
    "feedback_reply_too_long": "Reply is too long",
    "feedback_already_replied": "This message has already been answered",
    "trade_report_no_team": "No team to report from",
    "trade_report_invalid_type": "Invalid trade type",
    "trade_report_missing_id": "Missing trade id",
    "trade_report_message_too_short": "Say a bit more, in a sentence or two",
    "trade_report_message_too_long": "Message is too long",
    "trade_report_not_found": "Trade not found",
    "transfer_cooldown_active": "New teams can't send {cooldownAmount}+ CZ$ out in a single transfer or swap during their first {cooldownHours} hour(s). This unlocks in about {unlocksInHours} hour(s).",
    "auction_created_before_account": "Your team was created after this auction started, so you can't bid on it. Newer auctions are open to you right away.",
    "rate_forum": "Too many forum actions in a short time. Try again shortly.",
    "forum_invalid_category": "Invalid category",
    "forum_invalid_mute_flag": "Invalid choice",
    "forum_title_required": "A title is required",
    "forum_title_too_long": "The title is too long",
    "forum_body_required": "A message is required",
    "forum_body_too_long": "The message is too long",
    "forum_missing_id": "Missing id",
    "forum_missing_user": "Your session has expired. Log in again",
    "forum_post_not_found": "The post was not found. It may have been removed.",
    "forum_reply_not_found": "The reply was not found. It may have been removed.",
    "forum_poll_admin_only": "Only the admin can attach polls",
    "forum_category_admin_only": "Only I start threads in Roadmap. You can reply to any of them.",
    "forum_poll_invalid_options": "A poll needs 2 to 10 options of at most 100 characters",
    "forum_poll_option_not_found": "That poll option no longer exists",
    "forum_invalid_target_type": "Invalid report target",
    "forum_target_not_found": "The reported content was not found. It may have been removed.",
    "forum_reason_required": "A reason is required",
    "forum_reason_too_short": "The reason is too short",
    "forum_reason_too_long": "The reason is too long",
    "forum_report_not_found": "Report not found",
    "forum_invalid_pinned": "Invalid pin value",
    "forum_invalid_quote": "That reply can no longer be quoted",
    "forum_invalid_reaction_target_type": "Invalid target",
    "forum_reaction_target_not_found": "This content is no longer available",
    "forum_invalid_images": "Those images could not be attached. Try adding them again.",
    "forum_too_many_images": "You can add up to 3 images to a post.",
    "forum_image_not_owned": "That image does not belong to you.",
    "forum_image_not_found": "That image is no longer on this post.",
    "flash_custom_end_conflict": "Flash auctions run for a fixed 30 minutes and can't take a custom end time",
    "auction_end_invalid": "Pick a valid end time for the auction",
    "auction_end_too_soon": "An auction must run for at least {minHours} hour",
    "auction_end_too_late": "An auction can't run for more than {maxHours} hours",
    "auction_end_outside_window": "Auctions can only end while the market is open, between {openHour} and {closeHour}",
    "auction_end_crosses_season_transition": "Auctions can't end after the season change ({boundaryAt})",
    "season_end_already_claimed": "Season end already in progress or already completed",
    "session_expired": "Your session has expired. Log in again",
    "rate_dm": "Too many messages in a short time. Try again shortly.",
    "dm_body_invalid": "A message must be between 1 and 2000 characters.",
    "dm_invalid_recipient": "Pick a manager to write to.",
    "dm_recipient_not_found": "I could not find that manager.",
    "dm_not_found": "That conversation is gone.",
    "dm_invalid_block_target": "Pick a manager first.",
    "dm_report_reason_required": "Tell me what is wrong, in a sentence or two.",
    "dm_report_reason_too_long": "That reason is too long.",
    "beta_already_member": "You are already in the beta group.",
    "beta_request_pending": "Your request is already waiting for me.",
    "beta_not_member": "You are not in the beta group.",
    "beta_migration_pending": "Beta sign-up is not ready yet. Try again shortly.",
    "beta_invalid_payload": "That beta setting could not be read.",
    "flag_unknown": "That feature flag does not exist.",
    "flag_invalid_stage": "A feature can only be off, beta or on.",
    "flag_boolean_only": "This flag is on/off only and has no beta stage.",
    "contract_batch_empty": "Pick at least one rider to extend",
    "contract_batch_too_large": "You can extend at most {max} contracts at once",
    "contract_batch_invalid": "Each rider can be extended by 1 to {max} seasons",
    "contract_batch_duplicate": "The same rider was picked twice",
    "contract_batch_rejected": "Some contracts can't be extended. Nothing was changed",
    "contract_batch_salary_cap": "These extensions would take your total salary over the board's cap of {cap} CZ$. Nothing was changed",
    "contract_batch_write_failed": "Something went wrong saving a contract. Nothing was changed",
    "contract_batch_partial": "Some contracts changed while extending, and not every change could be undone. Check the riders below"
  }
}
